import React from "react";
import "./Blog.scss";
// Other components
import NavBar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const Blog = () => {
	return (
		<main>
			<NavBar active="blog" />
			<div className="header">
				<h1 className="title-blog-top">
					Welcome to the <span>blog!</span>
				</h1>
				<h2 className="subtitle-blog-top">
					Get ready to lose some brain cells...
				</h2>
			</div>

			<section className="blog">
				{/* Story object, just change the contents*/}
				<div className="story">
					<h1 className="title-blog">Finding something to write a blog on.</h1>
					<h2 className="date-blog">19 Feb, 2022</h2>
					<p className="content-blog">
						I don't wanna rant about random shit here lol
					</p>
				</div>
			</section>
			<Footer />
		</main>
	);
};

export default Blog;
